import { render } from "./ExpireButtonRenderer.vue?vue&type=template&id=3c9c6df2"
import script from "./ExpireButtonRenderer.vue?vue&type=script&lang=js"
export * from "./ExpireButtonRenderer.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__